import React from 'react';
import Text, { TEXT_VARIANTS } from 'ui/Typography/Text';
import { Icon, Modal } from 'ui/index';

const UploaderModal = ({ shown, onDismiss, children }) => {
  return (
    <Modal
      className="uploader-modal"
      shown={shown}
      onDismiss={onDismiss}
      enableFloatingDismiss
      canClickAway={false}
    >
      <div className="uploader-modal--body">
        <div className="ModalTakeover-title">
          <Text variant={TEXT_VARIANTS.TITLE}>
            {t('universal_uploader.modal.title')}
          </Text>
        </div>
        {children}
        <button
          className="ModalTakeover-closeButton u-resetBtn"
          onClick={onDismiss}
          type="button"
        >
          <Icon name="error" />
        </button>
      </div>
    </Modal>
  );
};

export { UploaderModal };
